import React from "react";
import "../../styles/components/sharing/SharingMobile.scss";
import FinalReadingModal from "../reading/FinalReadingModal";
import ErrorModal from "../utils/modal/ErrorModal";
import StoryImage from "../utils/StoryImage";
import AudioBookCreationModal from "../audiobook/AudioBookCreationModal";

const SharingMobile = ({
  index,
  setIndex,
  story: storyData,
  bookData,
  handleButtonClick,
  isReading,
  handleSpeechState,
  isSpeaking,
  isPlaying,
  imageSrc,
  handleAudioEnd,
  handleExit,
  showFinalReadingModal,
  setShowFinalReadingModal,
  showErrorModal,
  errorMessage,
  setShowErrorModal,
  commonProps,
  audioRef,
  pageName,
  navigate,
  USER_ID,
  showAudioModal,
  setShowAudioModal,
  isBookOpened,
  setIsBookOpened,
  showFlipbook,
  setShowFlipbook,
  showTitleOnCover,
  setShowTitleOnCover,
  bgImage,
  contentText,
}) => {
  const [showControls, setShowControls] = React.useState(false);
  const [isLandscape, setIsLandscape] = React.useState(
    window.innerWidth > window.innerHeight,
  );
  const [showRotationModal, setShowRotationModal] = React.useState(false);
  const touchStartX = React.useRef(0);
  const controlsTimerRef = React.useRef(null);
  const lastIndexRef = React.useRef(index);

  React.useEffect(() => {
    const handleResize = () => {
      setIsLandscape(window.innerWidth > window.innerHeight);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  React.useEffect(() => {
    if (lastIndexRef.current === -1 && index === 0) {
      setShowRotationModal(true);
    }
    lastIndexRef.current = index;
  }, [index]);

  const stopControlsTimer = (e) => {
    if (e) e.stopPropagation();
    if (controlsTimerRef.current) clearTimeout(controlsTimerRef.current);
  };

  const startControlsTimer = (e) => {
    if (e) e.stopPropagation();
    stopControlsTimer();
    controlsTimerRef.current = setTimeout(() => {
      setShowControls(false);
    }, 3000);
  };

  React.useEffect(() => {
    if (showControls) {
      startControlsTimer();
    } else {
      stopControlsTimer();
    }

    return () => {
      stopControlsTimer();
    };
  }, [showControls]);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    const touchEndX = e.changedTouches[0].clientX;
    const diffX = touchStartX.current - touchEndX;
    if (Math.abs(diffX) > 50) {
      if (diffX > 0) handleButtonClick("right");
      else handleButtonClick("left");
    }
  };

  const isNovel =
    bookData?.style === "graphic_novel" || bookData?.style === "그림 소설";

  const isCover = index === -1;

  const showCoverLayer = isCover || (index === 0 && isBookOpened);

  const currentStory = storyData[index >= 0 ? index : 0];
  const progressPercentage = Math.round(((index + 1) / storyData.length) * 100);

  const handleContainerClick = (e) => {
    if (isCover) return;
    const screenWidth = window.innerWidth;
    const clickX = e.clientX;

    if (clickX < screenWidth * 0.3) handleButtonClick("left");
    else if (clickX > screenWidth * 0.7) handleButtonClick("right");
    else setShowControls(!showControls);
  };

  const handleCoverClick = () => {
    if (isBookOpened) return;
    setIsBookOpened(true);

    setTimeout(() => {
      setIndex(0);

      setTimeout(() => {
        setIsBookOpened(false);
      }, 400);
    }, 600);
  };

  return (
    <div
      className={`sharing-mobile-container ${isCover ? "is-cover" : "is-reading"} ${isBookOpened ? "is-opening" : ""} ${isNovel ? "novel-style" : "drawing-style"} ${isLandscape ? "is-landscape" : "is-portrait"} ${showControls ? "show-controls" : ""}`}
      onClick={handleContainerClick}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      {}
      {!isCover && (
        <>
          {!isLandscape && (
            <div className="reading-view-logo">
              <img
                src="/images/logo/story4u-logo.svg"
                alt="STORY4U"
                loading="lazy"
                decoding="async"
              />
            </div>
          )}

          <section className="mobile-stories-section">
            <div
              key={index}
              className={`mobile-story-card ${isNovel ? "novel-style" : "general-style"} ${isBookOpened ? "content-fade-in" : ""}`}
            >
              {isLandscape && !isNovel && (
                <div className="general-top-logo">
                  <img
                    src="/images/logo/story4u-logo.svg"
                    alt="STORY4U"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              )}

              <div className="mobile-story-image-wrap">
                <img
                  src={bgImage}
                  alt="story"
                  className="mobile-story-image"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <div className="mobile-story-content">
                <p className="mobile-story-text">
                  {Array.isArray(contentText)
                    ? contentText.join(" ")
                    : contentText}
                </p>
                {isLandscape && isNovel && (
                  <div className="landscape-logo">
                    <img
                      src="/images/logo/story4u-logo.svg"
                      alt="STORY4U"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                )}
              </div>
            </div>
          </section>

          {!isBookOpened && (
            <>
              <div
                className="mobile-reading-controls"
                onClick={(e) => e.stopPropagation()}
                onMouseDown={stopControlsTimer}
                onMouseUp={startControlsTimer}
                onMouseLeave={startControlsTimer}
                onTouchStart={stopControlsTimer}
                onTouchEnd={startControlsTimer}
                onTouchMove={(e) => e.stopPropagation()}
              >
                <div className="controls-header">
                  <h3 className="controls-book-title">{bookData?.title}</h3>
                </div>
                <div className="controls-progress-wrapper">
                  <div className="progress-bar-container">
                    <input
                      type="range"
                      min="0"
                      max={storyData.length - 1}
                      value={index}
                      onChange={(e) => setIndex(parseInt(e.target.value, 10))}
                      className="progress-range-slider"
                    />
                  </div>
                  <div className="controls-info">
                    <span className="page-count">
                      <span className="current-page">{index + 1}</span> /{" "}
                      {storyData.length}
                    </span>
                    <span className="percentage-text">
                      {progressPercentage}%
                    </span>
                  </div>
                </div>
              </div>
              <div className="portrait-page-indicator">
                <span className="current">{index + 1}</span> /{" "}
                {storyData.length}
              </div>
            </>
          )}
        </>
      )}

      {}
      {showCoverLayer && (
        <div
          className={`mobile-cover-overlay ${isNovel ? "novel-style" : "drawing-style"} ${isBookOpened ? "animating" : ""}`}
        >
          {isNovel ? (
            /* ============================================================
               그림 소설 (Novel) 전용 표지 에셋 및 레이아웃
               ============================================================ */
            <div className="novel-cover-wrap">
              {isLandscape ? (
                <>
                  <div className="landscape-lamps">
                    <div className="lamp-left">
                      <img
                        src="/images/sharing/mobile/lamp-hor.svg"
                        alt=""
                        loading="lazy"
                        decoding="async"
                      />
                    </div>
                  </div>
                  <div className="cover-intro-text">
                    <p>클릭해서 그림 소설을</p>
                    <p>읽어볼까요?</p>
                  </div>
                  <div className="landscape-ornaments">
                    <img
                      src="/images/sharing/mobile/bottom-nikki-hor.svg"
                      alt=""
                      className="nikki-hor"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                  <div className="landscape-bottom-logos">
                    <img
                      src="/images/logo/magic4u-logo.svg"
                      alt="AI 매직포유"
                      className="magic4u-logo-hor"
                      loading="lazy"
                      decoding="async"
                    />
                    <img
                      src="/images/logo/story4u-logo.svg"
                      alt="STORY4U"
                      className="story4u-logo-hor"
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className="mobile-lamps">
                    <img
                      src="/images/sharing/mobile/lamp.svg"
                      alt=""
                      style={{ width: "100%" }}
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                  <div className="mobile-logo">
                    <img
                      src="/images/logo/magic4u-logo.svg"
                      alt="AI 매직포유"
                    />
                  </div>
                  <div className="cover-intro-text">
                    <p>클릭해서 그림 소설을</p>
                    <p>읽어볼까요?</p>
                  </div>
                  <img
                    src="/images/sharing/mobile/bottom-nikki.svg"
                    alt="bottom ornament"
                    className="bottom-nikki-bg"
                    loading="lazy"
                    decoding="async"
                  />
                  <img
                    src="/images/logo/story4u-logo.svg"
                    alt="story4u logo"
                    className="bottom-story4u-logo"
                    loading="lazy"
                    decoding="async"
                  />
                </>
              )}

              <div
                className={`cover-flip-wrapper ${isBookOpened ? "opened" : ""}`}
                onClick={handleCoverClick}
              >
                <div className="book-shelf-cover">
                  <div className="result-book-container">
                    <div className="result-book">
                      <div className="cover-content">
                        <img
                          src={bookData?.bookcover}
                          alt="cover"
                          loading="lazy"
                          decoding="async"
                        />
                        <h2
                          className={`novel-title ${!showTitleOnCover ? "hide" : ""}`}
                        >
                          {bookData?.title}
                        </h2>
                      </div>
                    </div>
                    <figure className="result-book-left">
                      <img
                        src="/images/utils/modal/novelFinalModal/book-left.svg"
                        alt="spine"
                        loading="lazy"
                        decoding="async"
                      />
                    </figure>
                    <figure className="result-book-bottom">
                      <img
                        src="/images/utils/modal/novelFinalModal/book-bottom.svg"
                        alt="pages"
                        loading="lazy"
                        decoding="async"
                      />
                    </figure>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            /* ============================================================
               그림 동화 (Drawing) 전용 표지 에셋 및 레이아웃
               ============================================================ */
            <div className="drawing-cover-wrap">
              <div className="drawing-top-assets">
                <img
                  src="/images/sharing/mobile/book-asset1.svg"
                  alt=""
                  className="top-left-asset"
                  loading="lazy"
                  decoding="async"
                />
                <img
                  src="/images/sharing/mobile/book-arial.svg"
                  alt=""
                  className="top-right-asset"
                  loading="lazy"
                  decoding="async"
                />
                <img
                  src="/images/sharing/mobile/book-nikki.svg"
                  alt=""
                  className="bottom-left-asset"
                  loading="lazy"
                  decoding="async"
                />
                <img
                  src="/images/sharing/mobile/book-asset2.svg"
                  alt=""
                  className="bottom-right-asset"
                  loading="lazy"
                  decoding="async"
                />
              </div>

              {isLandscape ? (
                <>
                  <div className="cover-intro-text">
                    <p>클릭해서 그림 동화를</p>
                    <p>읽어볼까요?</p>
                  </div>
                  <div className="landscape-ornaments">
                    <img
                      src="/images/sharing/mobile/book-bottom-hor.webp"
                      alt=""
                      className="nikki-hor"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                  <div className="landscape-bottom-logos">
                    <img
                      src="/images/logo/magic4u-logo.svg"
                      alt="AI 매직포유"
                      className="magic4u-logo-hor"
                      loading="lazy"
                      decoding="async"
                    />
                    <img
                      src="/images/logo/story4u-logo.svg"
                      alt="STORY4U"
                      className="story4u-logo-hor"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className="mobile-logo">
                    <img
                      src="/images/logo/magic4u-logo.svg"
                      alt="AI 매직포유"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                  <div className="cover-intro-text">
                    <p>클릭해서 그림 동화를</p>
                    <p>읽어볼까요?</p>
                  </div>
                  <img
                    src="/images/sharing/mobile/book-bottom.webp"
                    alt="bottom ornament"
                    className="bottom-nikki-bg"
                    loading="lazy"
                    decoding="async"
                  />
                  <img
                    src="/images/logo/story4u-logo.svg"
                    alt="story4u logo"
                    className="bottom-story4u-logo"
                    loading="lazy"
                    decoding="async"
                  />
                </>
              )}

              <div
                className={`cover-flip-wrapper ${isBookOpened ? "opened" : ""}`}
                onClick={handleCoverClick}
              >
                <div className="book-shelf-cover">
                  <div className="result-book-container">
                    <div className="result-book">
                      <div className="cover-content">
                        <img
                          src={bookData?.bookcover}
                          alt="cover"
                          loading="lazy"
                          decoding="async"
                        />
                        <h2
                          className={`novel-title ${!showTitleOnCover ? "hide" : ""}`}
                        >
                          {bookData?.title}
                        </h2>
                      </div>
                    </div>
                    <figure className="result-book-left">
                      <img
                        src="/images/sharing/mobile/book-left.svg"
                        alt="spine"
                        loading="lazy"
                        decoding="async"
                      />
                    </figure>
                    <figure className="result-book-bottom">
                      <img
                        src="/images/sharing/mobile/book-shelf.svg"
                        alt="pages"
                        loading="lazy"
                        decoding="async"
                      />
                    </figure>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {}
      <audio ref={audioRef} onEnded={handleAudioEnd} />

      {showRotationModal && !isLandscape && !isBookOpened && (
        <div
          className="rotation-guide-modal"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-header">
            <button
              className="modal-close-btn"
              onClick={() => setShowRotationModal(false)}
            >
              <img
                src="/images/utils/modal/close.svg"
                alt=""
                loading="lazy"
                decoding="async"
              />
              <span>닫기</span>
            </button>
          </div>
          <div className="modal-content">
            <h2 className="rotation-guide-title">
              핸드폰을 가로로 돌려서 보면
              <br />더 편하게 볼 수 있어요!
            </h2>
            <img
              src={`/images/sharing/mobile/${isNovel ? "novel-modal" : "drawing-modal"}.svg`}
              alt="Rotate your phone"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
      )}

      {showFinalReadingModal && (
        <FinalReadingModal
          onBack={() => {
            setShowFinalReadingModal(false);
            setIndex(-1);
          }}
          pageName={pageName}
          onClose={handleExit}
          isMobile={true}
        />
      )}

      {showErrorModal && (
        <ErrorModal
          error_message={errorMessage}
          onClose={() => {
            setShowErrorModal(false);
            navigate("/storyland");
          }}
        />
      )}

      {showAudioModal && (
        <AudioBookCreationModal
          bookData={bookData}
          userID={USER_ID}
          onClose={() => setShowAudioModal(false)}
        />
      )}

      {}
      <div
        className={`transition-fade-overlay ${isBookOpened ? "active" : ""}`}
      />
    </div>
  );
};

export default SharingMobile;
